import React from 'react';
import BoardingProgress from '../../BoardingProgress.js';
import { useTranslation } from 'react-i18next';
import { Divider, Label } from '@fluentui/react-components';
import { BuildingRegular } from '@fluentui/react-icons';
import CompanyDataPreview from './CompanyDataPreview.js';



const Preview = ({ setCurrentStep, setCompanyIdDetect }) => {
  const currentProgressStep = 2
  const { t } = useTranslation();


  return (
    <>
      <div
        style={{
          display: 'flex',
          minWidth: '1400px',
          minheight: '1100px',
          margin: 'auto',
          flexDirection: 'column',
          alignContent: 'center',
          background: '#FAF9F8'
        }}
      >
        <div style={{
          width: '1400px',
          backgroundColor: '#fffff',
          margin: '0 auto',
          height: '1600px',
          
        }}>
          <BoardingProgress currentProgressStep={currentProgressStep} />
          <div style={{
            marginTop: '10px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'center'
          }}>
            <Divider style={{ width: '1200px', marginTop: '40px' }} />
          </div>
          <div style={{ color: 'black', display: 'flex', marginTop: '20px', width: '100%', justifyContent: 'center', }}>

            <div><BuildingRegular style={{ fontSize: '20px' }} /></div>
            <div><Label size='large' style={{ fontSize: '20px', }}>{t('boarding.checkCompanyInformation')}</Label></div>

          </div>

          <CompanyDataPreview setCurrentStep={setCurrentStep} setCompanyIdDetect={setCompanyIdDetect}  />
        </div>
      </div>



    </>
  );
};

export default Preview;
